import MeetingMinutesLanding from './index.vue'
import MeetingMinutesDetails from './detail'
import PermSchema from '@/modules/acl/permission_schema'

export default [
  {
    path: '/meeting-minutes',
    component: MeetingMinutesLanding
  },
  {
    name: '/meeting-minutes/detail',
    path: '/meeting-minutes/detail',
    component: MeetingMinutesDetails,
    props: (route) => ({
      id: route.query.id ? route.query.id : route.params.id,
      mode: route.query.mode ? route.query.mode : route.params.mode ? route.params.mode : route.query.id ? 'EDIT' : 'CREATE',
      data: route.params.data
    })
  }
]